// This file contains material which is the pre-existing property of Psycle
// Interactive Limited.
// Copyright (c) 2018 Psycle Interactive. All rights reserved.

const casestudyData = {
  id: 'fabricius',
  heroImg: 'hero.jpg',
  heroTheme: 'dark',
  heroHeadingOne: 'Fabricius',
  heroHeadingTwo: 'Bringing machine learning to the masses',
  details: [
    {
      title: 'AGENCY',
      items: ['Psycle'],
    },
    {
      title: 'CLIENT',
      items: ['Google Arts & Culture'],
    },
    {
      title: 'TECHNOLOGY',
      items: ['AutoML', 'AutoML Vision', 'Google Cloud Platform', 'Angular', 'Python 3', 'Animation', 'Video production'],
    },
  ],
  heading: 'Explaining machine learning innovation to the widest possible audience',
  challengeImg: 'challenge.jpg',
  challenge: ['Create an experience that explains the fundamentals of translating hieroglyphs to a non-technical audience'],
  solutionImg: 'solution.jpg',
  solution: [
    'Creating an experience that breaks down the Fabricius project, the next stage of the Hieroglyphics Initiative, into three phases: <ol><li>Play - A messaging platform tied to the Ancient Egyptian dictionary that powers Fabricius’s translation processes into a fun messaging experience for sharing on social media.</li><li>Learn - Understand more about Ancient Egyptian hieroglyphs and the process used by academics to translate them.</li><li>Work - The Open Source version of the workbench we created for academics to support the translation of Middle Egyptian hieroglyphs.</li></ol>',
    `Combining innovation, interaction and video to clearly explain the complex ideas of translating Ancient Egyptian and machine learning.`,
    'Working closely with the Google Arts & Culture team and Macquarie University to ensure that all content was targeted correctly and balanced education with not diminishing the work of academics and the achievement of completing Fabricius, a journey that started three years before.',
  ],
  carousel: [
    {
      img: 'callout_1.jpg',
      title: 'Video',
      content: ['Animated introduction sets the tone for the Google Arts & Culture experience'],
    },
    {
      img: 'callout_2.gif',
      title: 'Interactive Learning',
      content: ['Working with academics to break the translation of Ancient Egyptian hieroglyphs into six steps'],
    },
    {
      img: 'callout_3.jpg',
      title: 'Open Source',
      content: ['Fulfilling the promises that were made in 2017 to make the tools and data available to everyone'],
    },
  ],
  nextCaseStudy: 'hieroglyphics-initiative',
};

export default casestudyData;
